export default __webpack_public_path__ + "static/media/111.f02f9850.jpg";